(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cms-full-bleed-quote"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.cms-full-bleed-quote').forEach(function (section) {
  var img = section.querySelector('.bleed-img');
  var rm = matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!img || rm) return;
  var ticking = false;
  addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      var r = section.getBoundingClientRect();
      if (r.bottom > 0 && r.top < innerHeight) {
        img.style.transform = 'translateY(' + ((r.top + r.height / 2 - innerHeight / 2) * -0.08) + 'px)';
      }
    });
  }, { passive: true });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cms-home-hero"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.cms-home-hero').forEach(function (hero) {
  // JIS 2026-09-25: was window 'load' (~4.5 s on the live page); start as soon as the DOM is ready
  var go = function () { requestAnimationFrame(function () { hero.classList.add('is-loaded'); }); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go); else go();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cms-install-library"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.cms-install-library').forEach(function (root) {
  var grid = root.querySelector('[data-il-grid]');
  if (!grid) return;

  var input = root.querySelector('[data-il-search]');
  var chips = Array.prototype.slice.call(root.querySelectorAll('[data-il-cat]'));
  var items = Array.prototype.slice.call(grid.querySelectorAll('[data-il-item]'));
  var countEl = root.querySelector('[data-il-count]');
  var emptyEl = root.querySelector('[data-il-empty]');
  var chipButtons = chips.filter(function (c) { return c.tagName === 'BUTTON'; });

  var activeCat = '';
  var query = '';

  function apply() {
    var shown = 0;
    items.forEach(function (item) {
      var haystack = item.getAttribute('data-il-text') || '';
      var cat = item.getAttribute('data-il-cat') || '';
      var okCat = !activeCat || cat === activeCat;
      var okText = !query || haystack.indexOf(query) !== -1;
      var visible = okCat && okText;
      if (visible) {
        item.removeAttribute('hidden');
        shown++;
      } else {
        item.setAttribute('hidden', '');
      }
    });

    if (countEl) {
      countEl.textContent = shown === items.length
        ? countEl.getAttribute('data-all') || (items.length + ' documents')
        : shown + ' of ' + items.length;
    }
    if (emptyEl) {
      if (shown === 0) { emptyEl.removeAttribute('hidden'); }
      else { emptyEl.setAttribute('hidden', ''); }
    }
  }

  if (countEl) countEl.setAttribute('data-all', items.length + ' documents');

  chipButtons.forEach(function (chip) {
    chip.addEventListener('click', function () {
      activeCat = chip.getAttribute('data-il-cat') || '';
      chipButtons.forEach(function (c) {
        var on = c === chip;
        c.classList.toggle('is-on', on);
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      apply();
    });
  });

  if (input) {
    input.addEventListener('input', function () {
      query = input.value.trim().toLowerCase();
      apply();
    });
  }

  apply();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cms-size-finder"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.cms-size-finder').forEach(function (root) {
  var track = root.querySelector('.sizer-track');
  if (!track) return;
  var sizes = JSON.parse(track.getAttribute('data-sizes') || '[]');
  if (!sizes.length) return;

  var handle = root.querySelector('.sizer-handle');
  var fill = root.querySelector('.sizer-fill');
  var valueEl = root.querySelector('.sizer-readout .num');
  var cabCard = root.querySelector('[data-role="cab"]');
  var drwCard = root.querySelector('[data-role="drw"]');
  var cabLabel = cabCard ? cabCard.querySelector('.v') : null;
  var drwLabel = drwCard ? drwCard.querySelector('.v') : null;
  var tickLabels = root.querySelectorAll('.sizer-tick-label');
  var cabPicks = root.querySelector('[data-role="cabp"]');
  var drwPicks = root.querySelector('[data-role="drwp"]');
  var fitsTemplate = root.getAttribute('data-fits-template') || 'Fits {n}″ openings';
  var notMadeLabel = root.getAttribute('data-not-made-label') || 'Not made at this size';
  var defaultInches = parseFloat(root.getAttribute('data-default-inches'));

  var MIN = sizes[0].n;
  var MAX = sizes[sizes.length - 1].n;

  function pctForValue(v) {
    return (v - MIN) / (MAX - MIN) * 100;
  }
  function nearestIdx(value) {
    var best = 0, bd = Infinity;
    sizes.forEach(function (s, i) {
      var d = Math.abs(s.n - value);
      if (d < bd) { bd = d; best = i; }
    });
    return best;
  }
  function valueFromClientX(clientX) {
    var rect = track.getBoundingClientRect();
    var pct = (clientX - rect.left) / rect.width;
    pct = Math.max(0, Math.min(1, pct));
    return MIN + pct * (MAX - MIN);
  }
  function render(idx) {
    var s = sizes[idx];
    var pct = pctForValue(s.n);
    handle.style.left = pct + '%';
    fill.style.width = pct + '%';
    handle.setAttribute('aria-valuenow', s.n);
    if (valueEl) valueEl.textContent = s.n;
    tickLabels.forEach(function (el) {
      el.classList.toggle('active', +el.dataset.n === s.n);
    });
    // JIS 2026-09-25: the result answers - live count + 3 products per card
    var fitsLine = function (count) {
      return count > 0 ? count + ' fit a ' + s.n + '\u2033 opening' : fitsTemplate.replace('{n}', s.n);
    };
    var picks = function (el, list) {
      if (!el) return;
      el.innerHTML = '';
      (list || []).forEach(function (p) {
        var a = document.createElement('a'); a.href = p.u;
        var im = document.createElement('img'); im.loading = 'lazy'; im.alt = ''; if (p.i) im.src = p.i; a.appendChild(im);
        var t = document.createElement('span'); t.className = 'pt'; t.textContent = p.t; a.appendChild(t);
        var pr = document.createElement('span'); pr.className = 'pp'; pr.textContent = p.p; a.appendChild(pr);
        el.appendChild(a);
      });
    };
    if (cabCard) {
      if (s.cab) {
        cabCard.setAttribute('href', s.cab);
        cabCard.classList.remove('disabled');
        if (cabLabel) cabLabel.textContent = fitsLine(s.cabN);
        picks(cabPicks, s.cabP);
      } else {
        cabCard.removeAttribute('href');
        cabCard.classList.add('disabled');
        if (cabLabel) cabLabel.textContent = notMadeLabel;
        picks(cabPicks, []);
      }
    }
    if (drwCard && s.drw) {
      drwCard.setAttribute('href', s.drw);
      if (drwLabel) drwLabel.textContent = fitsLine(s.drwN);
      picks(drwPicks, s.drwP);
    }
  }

  var dragging = false;
  handle.addEventListener('pointerdown', function (e) {
    dragging = true;
    handle.setPointerCapture(e.pointerId);
  });
  window.addEventListener('pointermove', function (e) {
    if (dragging) render(nearestIdx(valueFromClientX(e.clientX)));
  });
  window.addEventListener('pointerup', function () {
    dragging = false;
  });
  track.addEventListener('click', function (e) {
    if (e.target !== track) return;
    render(nearestIdx(valueFromClientX(e.clientX)));
  });
  handle.addEventListener('keydown', function (e) {
    var cur = sizes.findIndex(function (s) {
      return s.n === +handle.getAttribute('aria-valuenow');
    });
    if (e.key === 'ArrowRight' || e.key === 'ArrowUp') {
      render(Math.min(sizes.length - 1, cur + 1));
      e.preventDefault();
    }
    if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') {
      render(Math.max(0, cur - 1));
      e.preventDefault();
    }
  });
  tickLabels.forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.stopPropagation();
      render(sizes.findIndex(function (s) {
        return s.n === +el.dataset.n;
      }));
    });
  });

  var initialIdx = sizes.findIndex(function (s) { return s.n === defaultInches; });
  if (initialIdx < 0) initialIdx = Math.floor(sizes.length / 2);
  render(initialIdx);
});

  } catch(e) { console.error(e); }
})();
})();
